import React, { useEffect, useState } from 'react';

import { Modal } from '@mui/material';
import EventEmitter from 'reactjs-eventemitter';
import '../../../styles/Modal.scss';

export const ModalManager = {
  instance: undefined,

  showDefaultModal(message, onClose = () => {}, open = true, messageProps = {}, modalProps = {}) {
    const keyModal = 'defaultModal';
    const { allowBackdropClick = true } = modalProps;
    const handleOnclose = (event, reason) => {
      if (reason === 'backdropClick' && !allowBackdropClick) return;
      ModalManager.closeModal(keyModal);
      onClose(keyModal);
    };

    const component = (
      <div className="default-modal" {...messageProps}>
        {message}
      </div>
    );
    ModalManager.registerModal(keyModal, open, component, {
      onClose: handleOnclose,
      ...modalProps,
    });
    return keyModal;
  },

  showCustomModal(key, component, modalProps, open = true) {
    ModalManager.registerModal(key, open, component, modalProps);
  },

  closeModal(key = 'defaultModal') {
    ModalManager.setOpenModal(key, false);
  },
  openModal(key) {
    ModalManager.setOpenModal(key, true);
  },

  registerModal(key, open, component, propsComponent) {
    const [modals, setModal] = ModalManager.instance;
    const newModals = modals;
    newModals[key] = {
      key,
      open,
      component,
      props: propsComponent,
    };
    setModal(newModals);
  },

  setOpenModal(key, isOpen) {
    const [modals, setModal] = ModalManager.instance;
    const newModals = modals;
    if (newModals[key]) {
      newModals[key].open = isOpen;
    }
    setModal(newModals);
  },
};

const ModalProvider = () => {
  const [modals, setModals] = useState({});

  const updateModals = (newModals) => {
    setModals({ ...newModals });
  };

  useEffect(() => {
    const clearModalsOnLogout = () => setModals({});
    EventEmitter.subscribe('logout', clearModalsOnLogout);
  }, []);

  useEffect(() => {
    ModalManager.instance = [modals, updateModals];
  }, [modals]);

  return (
    <React.Fragment>
      {Object.values(modals)
        .filter((modalData) => modalData.open)
        .map((modalData) => (
          <Modal key={modalData.key} open sx={{ overflow: 'auto' }} {...modalData.props}>
            {modalData.component}
          </Modal>
        ))}
    </React.Fragment>
  );
};

export default ModalProvider;
